import { fetchData } from "@client";

export async function checkSSOLinkQuery(link ) {
  return await fetchData(`/v1/sso-activation/${link}`);
}